import { createSlice } from '@reduxjs/toolkit';

export interface entraIdProps{
  name:string;
  uid:string;
  type:string;
}
export interface entraIdGroupProps{
  entraId:entraIdProps
  list?:entraIdProps[]
}

const initialState: entraIdGroupProps = {
  entraId: { name: '', uid: '',type:'' },
  list: [],
};
const entraIdGroupSlice = createSlice({
  name: 'entraId',
  initialState,
  reducers: {
    setEntraIdGroups: (state, action) => {
      state.list = action.payload;
    },
   
  },
});

export const { setEntraIdGroups } = entraIdGroupSlice.actions;
export default entraIdGroupSlice.reducer;
